export default [
  {
    label: t('lessons.editor.elements.free_response'),
    type: 'free_response',
    model: 'Questions::FreeResponse',
  },
  {
    label: t('lessons.editor.elements.multiple_choice'),
    type: 'multiple_choice',
    model: 'Questions::MultipleChoice',
  },
  {
    label: t('lessons.editor.elements.multiple_select'),
    type: 'multiple_select',
    model: 'Questions::MultipleSelect',
  },
  {
    label: t('lessons.editor.elements.survey'),
    type: 'survey',
    model: 'Questions::Survey',
  },
];
